export default "assets/images/logo-8b586522.png";